<template>
  <div class="sidebar" :style="{ width: sidebarDivWidth }">
    <nav class="sidebar-nav" id="sidebar-nav" :style="getHeight1">
      <ul class="nav" :style="{ width: navUlWidth }">
        <template v-for="item in routes">
          <template v-if="nowPage == item.path">
            <router-link
              tag="li"
              :class="navClass1"
              :to="item.path + '' + item.children[0].path"
              v-if="!item.hidden && item.children && item.children.length > 0"
              disabled
            >
              <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                <Icon :type="item.icon" color="white" @click="handleClick2" />
                <span :style="navStyleObject" @click="handleClick2"
                  >{{ item.name }}
                </span>
              </div>
              <ul class="nav-dropdown-items">
                <li
                  :class="navClass2"
                  v-for="child in item.children"
                  v-if="!child.hidden"
                  @click="addActive"
                >
                  <router-link
                    @click.native="flushCom()"
                    :to="
                      item.path +
                      '/' +
                      child.path +
                      '/' +
                      child.children[0].path
                    "
                    class="nav-link"
                    v-if="!child.hidden && child.children"
                  >
                    <router-link
                      tag="li"
                      style="background: rgba(0, 0, 0, 0)"
                      :class="navClass3"
                      :to="item.path + '' + child.children[0].path"
                      v-if="
                        !item.hidden &&
                        item.children &&
                        item.children.length > 0
                      "
                      disabled
                    >
                      <div
                        class="nav-link nav-dropdown-toggle"
                        @click="handleClick"
                      >
                        <span :style="navStyleObject2">{{ child.name }} </span>
                      </div>
                      <ul class="nav-dropdown-items" style="">
                        <li
                          :class="navClass3"
                          v-for="grandson in child.children"
                          v-if="!child.hidden"
                          @click="addActive"
                          style="background: rgba(0, 0, 0, 0.1)"
                        >
                          <router-link
                            @click.native="flushCom()"
                            :to="
                              item.path +
                              '/' +
                              child.path +
                              '/' +
                              grandson.path +
                              '/' +
                              grandson.children[0].path
                            "
                            class="nav-link"
                            v-if="!grandson.hidden && grandson.children"
                          >
                            <Icon :type="grandson.icon" color="white" />
                            <span :style="navStyleObject3"
                              >{{ grandson.name }}
                            </span>
                          </router-link>
                          <router-link
                            @click.native="flushCom()"
                            :to="
                              item.path + '/' + child.path + '/' + grandson.path
                            "
                            class="nav-link"
                            v-else="!grandson.children"
                            ><Icon :type="grandson.icon" color="white" />
                            <span :style="navStyleObject3"
                              >{{ grandson.name }}
                            </span>
                          </router-link>
                        </li>
                      </ul>
                    </router-link>
                  </router-link>
                  <router-link
                    @click.native="flushCom()"
                    :to="item.path + '/' + child.path"
                    class="nav-link"
                    v-else="!child.children"
                    style="padding-left: 30px"
                    ><Icon :type="child.icon" color="white" />
                    <span :style="navStyleObject2">{{ child.name }} </span>
                  </router-link>
                </li>
              </ul>
            </router-link>
          </template>
          <template v-if="nowPage != item.path">
            <router-link
              tag="li"
              :class="navClass"
              :to="item.path + '' + item.children[0].path"
              v-if="!item.hidden && item.children && item.children.length > 0"
              disabled
            >
              <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                <Icon :type="item.icon" color="white" @click="handleClick2" />
                <span :style="navStyleObject" @click="handleClick2"
                  >{{ item.name }}
                </span>
              </div>
              <ul class="nav-dropdown-items">
                <li
                  :class="navClass2"
                  v-for="child in item.children"
                  v-if="!child.hidden"
                  @click="addActive"
                >
                  <router-link
                    @click.native="flushCom()"
                    :to="
                      item.path +
                      '/' +
                      child.path +
                      '/' +
                      child.children[0].path
                    "
                    class="nav-link"
                    v-if="!child.hidden && child.children"
                  >
                    <router-link
                      tag="li"
                      style="background: rgba(0, 0, 0, 0)"
                      :class="navClass3"
                      :to="item.path + '' + child.children[0].path"
                      v-if="
                        !item.hidden &&
                        item.children &&
                        item.children.length > 0
                      "
                      disabled
                    >
                      <div
                        class="nav-link nav-dropdown-toggle"
                        @click="handleClick"
                      >
                        <span :style="navStyleObject2">{{ child.name }} </span>
                      </div>
                      <ul class="nav-dropdown-items" style="">
                        <li
                          :class="navClass3"
                          v-for="grandson in child.children"
                          v-if="!child.hidden"
                          @click="addActive"
                          style="background: rgba(0, 0, 0, 0.1)"
                        >
                          <router-link
                            @click.native="flushCom()"
                            :to="
                              item.path +
                              '/' +
                              child.path +
                              '/' +
                              grandson.path +
                              '/' +
                              grandson.children[0].path
                            "
                            class="nav-link"
                            v-if="!grandson.hidden && grandson.children"
                          >
                            <Icon :type="grandson.icon" color="white" />
                            <span :style="navStyleObject3"
                              >{{ grandson.name }}
                            </span>
                          </router-link>
                          <router-link
                            @click.native="flushCom()"
                            :to="
                              item.path + '/' + child.path + '/' + grandson.path
                            "
                            class="nav-link"
                            v-else="!grandson.children"
                          >
                            <Icon :type="grandson.icon" color="white" />
                            <span :style="navStyleObject3"
                              >{{ grandson.name }}
                            </span>
                          </router-link>
                        </li>
                      </ul>
                    </router-link>
                  </router-link>
                  <router-link
                    @click.native="flushCom()"
                    :to="item.path + '/' + child.path"
                    class="nav-link"
                    v-else="!child.children"
                    style="padding-left: 30px"
                  >
                    <Icon :type="child.icon" color="white" />
                    <span :style="navStyleObject2">{{ child.name }} </span>
                  </router-link>
                </li>
              </ul>
            </router-link>
          </template>
          <li class="nav-item" v-if="!item.hidden && !item.children">
            <router-link
              @click.native="flushCom()"
              :to="item.path"
              class="nav-link"
              exact
            >
              <Icon :type="item.icon" color="white" />
              <span class="adt-span-special" :style="navStyleObject"
                >{{ item.name }}
              </span>
            </router-link>
          </li>
        </template>
      </ul>
    </nav>
  </div>
</template>

<script>
import router from "../router";
import { getSystemUnitCode } from "../api/home";

export default {
  name: "SidebarItem",
  props: {
    routes: {
      type: Array,
    },
  },
  data() {
    return {
      navStyleObject: {
        position: "absolute",
        marginTop: "1px",
        marginLeft: "1px",
      },
      navStyleObject1: {
        position: "absolute",
        marginTop: "1px",
        marginLeft: "30px",
      },
      navStyleObject2: {
        position: "absolute",
        marginTop: "1px",
        marginLeft: "1px",
      },
      navStyleObject3: {
        position: "absolute",
        marginTop: "1px",
        marginLeft: "10px",
      },
      navClass: "nav-item nav-dropdown level1",
      navClass1: "nav-item nav-dropdown open level1",
      navClass2: "nav-item level2",
      navClass3: "nav-item",
      nowPage: "",
      navWidth: "290px",
      navUlWidth: "290px",
      sidebarDivWidth: "290px",
      nowTarget: {},
      heightChange: "",
      getHeight1: {},
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    this.initSidebar();
    this.initSidebar1();
    getSystemUnitCode()
      .then((res) => {
        if (res.data.data.unitCode == "qitongcha") {
          this.heightChange = "65px";
        } else if (res.data.data.unitCode == "CEI") {
          this.heightChange = "120px";
        }
        this.getHeight(this.heightChange);
      })
      .catch((err) => {});
  },
  methods: {
    getHeight(item) {
      let w = `100vh`;
      this.getHeight1 = {
        height: `calc(${w} - ${item})`,
        width: this.navWidth,
      };
    },
    handleResize() {
      this.initSidebar1();
    },
    handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle("open");
    },
    handleClick2(e) {
      e.preventDefault();
      e.target.parentElement.parentElement.classList.toggle("open");
    },
    addActive(e) {
      e.preventDefault();
      e.target.parentElement.parentElement.parentElement.classList.add("open");
    },
    initSidebar() {
      let path = this.$route.path;
      let arr = path.split("/");
      arr.forEach((e, index) => {
        if (index == 1) {
          this.nowPage = "/" + e;
        }
      });
      console.log(this.nowPage, "nowpage");
      let array = ([] = $("body").attr("class").split(" "));
      if (array.indexOf("sidebar-minimized") >= 0) {
        if (array.indexOf("sidebar-minimized") >= 0) {
          this.navStyleObject = {
            position: "",
            marginTop: "-1px",
            marginLeft: "30px",
          };
        } else {
          this.navStyleObject = {
            position: "absolute",
            marginTop: "1px",
            marginLeft: "30px",
          };
        }
      }
      // let nextPage = this.$store.getters.nextPage;
      // nextPage = decodeURIComponent(nextPage);
      // this.$router.push({ path: tmp+nextPage})
    },
    initSidebar1() {
      const width = document.body.clientWidth || document.body.scrollWidth;
      const big = this.$store.getters.sidebarBigWidth;
      const small = this.$store.getters.sidebarSmallWidth;
      const critical = this.$store.getters.sidebarCriticalValue;
      if (width > critical) {
        this.navWidth = big + "px";
        this.navUlWidth = big + "px";
        this.sidebarDivWidth = big + "px";
      } else {
        this.navWidth = small + "px";
        this.navUlWidth = small + "px";
        this.sidebarDivWidth = small + "px";
      }
    },
    flushCom() {
      // const fromPath = this.$store.getters.fromPath;
      // this.$store.dispatch('setFromPath',this.$route.path);
      // if(fromPath != "" && this.$route.path == fromPath){
      //     this.$router.go(0);
      // }
      //解决同一组件路由跳转，数据不刷新问题
      /*  let i = 0;
                router.beforeEach((to, from, next) => {
                    i = i+1;
                    alert(from.path)
                    this.$store.dispatch('setFromPath',from.path);
                    next();
                });
                const fromPath = this.$store.getters.fromPath;
                const toPath = this.$route.path;
                console.log("from="+fromPath);
                console.log("to="+toPath);
                if(fromPath === toPath){
                    this.$router.go(0);
                }*/
    },
  },
  computed: {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.wscn-icon {
  margin-right: 10px;
}
.hideSidebar .menu-indent {
  display: block;
  text-indent: 10px;
}
</style>




// WEBPACK FOOTER //
// SidebarItem.vue?a4c08402